import styled from 'styled-components'
import { colors } from '~/assets/styleConstants'

const Track = styled.div`
    position: relative;
    width: 36px;
    height: 14px;
    border-radius: 40px;
    background-color: ${colors.captureGrey300};
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
`

const Handle = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${(props: { isOn?: boolean }) =>
        props.isOn ? colors.captureBlue : colors.captureGrey700};
    position: absolute;
    transform: translateX(${(props) => (props.isOn ? '20px' : '0px')});
    transition: transform 0.2s;
    box-shadow: 0 0 4px 0px ${colors.defaultIconColor};
`

export const ToggleSwitch: React.FunctionComponent<{
    isOn: boolean
    onClick: () => void
}> = (props) => (
    <Track
        onClick={props.onClick}
        onKeyUp={props.onClick}
        role="button"
        tabIndex={0}>
        <Handle isOn={props.isOn} />
    </Track>
)
